const crud = { c: false, r: false, u: false, d: false };

export const tenants = Object.freeze({
  tenant: { ...crud },
});
